var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1566,
    viewBox: "0 0 1920 1566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12024_13506)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_12024_13506)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 771,
    cy: 1116,
    r: 189,
    fill: "#0347F5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_12024_13506)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 439,
    cy: 189,
    r: 189,
    fill: "#0347F5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f_12024_13506)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1435,
    cy: 379,
    r: 162,
    fill: "#B603F5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_12024_13506",
    x: -218,
    y: 127,
    width: 1978,
    height: 1978,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 400,
    result: "effect1_foregroundBlur_12024_13506"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12024_13506",
    x: -450,
    y: -700,
    width: 1778,
    height: 1778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 350,
    result: "effect1_foregroundBlur_12024_13506"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_12024_13506",
    x: 773,
    y: -283,
    width: 1324,
    height: 1324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_12024_13506"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12024_13506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1715,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.7c6233e84d303167a60127ab86dbe7f3.svg";
export { ForwardRef as ReactComponent };